import { Fragment, useCallback, useEffect, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import InputMask from "react-input-mask";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";
import { useSelector } from "react-redux";
import { getUserEmailSelector } from "../../../app/appSelectors.js";

function PaymentForm(props) {
    const {
        formData,
        formError = {},
        onChangeField,
        log,
        valuesRef,
    } = props;

    const { getLangPath } = useLangContext();
    const [values, setValues] = useState({});
    const userEmail = useSelector(getUserEmailSelector);

    useEffect(() => {
        valuesRef.current = values;
    }, [values, valuesRef]);

    useEffect(() => {
        if (formData.length) {
            const newValues = {};
            formData.forEach(item => {
                if (!values[item.field] && item.input_mode === 'select') {
                    newValues[item.field] = localStorage.getItem(`payment_form.${item.field}`) || item.options[0].value;
                } else if (!values[item.field]) {
                    const value = localStorage.getItem(`payment_form.${item.field}`);
                    !!value && (newValues[item.field] = value);
                }
                if (item.field === 'email' && !values[item.field]) {
                    newValues[item.field] = userEmail;
                }
            });
            if (Object.keys(newValues).length) {
                setValues({
                    ...values,
                    ...newValues,
                });
            }
        }
    }, [formData, userEmail, values]);

    const changeHandler = useCallback((e) => {
        const name = e.target.name;
        const value = e.target.value;
        localStorage.setItem(`payment_form.${name}`, value);
        setValues({
            ...values,
            [name]: value,
        });
        if (onChangeField) {
            onChangeField(name, value);
        }
    }, [onChangeField, values]);

    const blurHandler = useCallback((e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (log) {
            log({
                field: name,
                value,
            });
        }
    }, [log]);

    const getIsFieldHidden = useCallback((fieldName) => {
        const currentField = formData.find(item => item.field === fieldName);
        if (currentField?.condition) {
            const arr = Array.isArray(currentField.condition.value)
                ? currentField.condition.value
                : [currentField.condition.value];
            return !arr.includes(values[currentField.condition.field]);
        }
        return false;
    }, [formData, values]);

    const getFormField = useCallback((item) => {
        const isHidden = getIsFieldHidden(item.field);
        let input_mode = item.input_mode;
        if (input_mode === 'email' || input_mode === 'date') {
            input_mode = 'text';
        }
        switch (item.input_mode) {
            case 'select':
                return <Form.Group className={'mb-3' + (isHidden ? ' d-none' : '')}>
                    <OverlayTrigger
                        placement={'top'}
                        overlay={
                            <Tooltip>{getLangPath('forms.' + item.label)}</Tooltip>
                        }
                        delay={{
                            show: 1000,
                            hide: 0,
                        }}
                    >
                        <Form.Select name={item.field}
                                     value={values[item.field]}
                                     placeholder={getLangPath('forms.' + item.label)}
                                     onChange={changeHandler}
                                     onBlur={blurHandler}
                                     required={!isHidden}
                        >
                            {
                                item.options.map(selItem => <Fragment key={selItem.label}>
                                    <option value={selItem.value}>{selItem.label}</option>
                                </Fragment>)
                            }
                        </Form.Select>
                    </OverlayTrigger>
                </Form.Group>
            case 'date':
            case 'email':
            case 'tel':
            case 'text':
            default:
                const props = {}
                if (item.mask) {
                    props.as = InputMask;
                    props.mask = values[item.field] ? item.mask : null;
                    // props.maskChar = null;
                }
                return <Form.Group className={'mb-3' + (isHidden ? ' d-none' : '')}>
                    <OverlayTrigger
                        placement={'top'}
                        overlay={
                            <Tooltip>{getLangPath('forms.' + item.label)}</Tooltip>
                        }
                        delay={{
                            show: 1000,
                            hide: 0,
                        }}
                    >
                        <Form.Control type={input_mode}
                                      name={item.field}
                                      defaultValue={values[item.field]}
                                      placeholder={getLangPath('forms.' + item.label)}
                                      required={!isHidden}
                            // pattern={item.input_pattern}
                                      onChange={changeHandler}
                                      onBlur={blurHandler}
                                      isInvalid={!!formError[item.field]}
                                      {...props}
                        />
                    </OverlayTrigger>
                    {
                        formError?.[item.field] &&
                        <Form.Text
                            className="form-valid-hint text-error">{getLangPath(formError[item.field])}</Form.Text>
                    }
                </Form.Group>
        }
    }, [getIsFieldHidden, getLangPath, values, changeHandler, blurHandler, formError]);

    return <>
        {
            formData.length > 0 && <Form.Label className={'mt-3 mb-3'}>{getLangPath('deposit.additional_information')}</Form.Label>
        }
        {
            formData.map(item => <Fragment key={item.field}>
                {getFormField(item)}
            </Fragment>)
        }
        {
            !!formError?.common && <div className="text-danger mt-2">{getLangPath(formError.common)}</div>
        }
    </>
}

export default PaymentForm;
